import { Injectable } from '@angular/core';
import { LookupManagerService } from "../../../rms/app/api/services/lookup-manager.service";

@Injectable()
export class LookupService {
  private lookupData: any = {};
  constructor(private lookupManager: LookupManagerService) { }

  loadLookups(lookups: any) {
    this.lookupData = Object.assign({}, this.lookupData, lookups);
  }
  retrieve(lookups: any[]) {
    return new Promise<void>((resolve) => {
      let findList = lookups.map((lookup) => {
        if (!this.lookupData[lookup])

          return lookup;
      });
      this.lookupManager.GetLookups(findList).subscribe((res) => {
        this.lookupData = Object.assign({}, res, this.lookupData);
        resolve();
      });
    });
  }
  set(lookupDataSetName: string, lookups: any[]) {
    this.lookupData[lookupDataSetName] = lookups;
  }
  get(lookupDataSetName: string, lookupKey?: string) {
    if (this.lookupData) {
      if (lookupKey) {
        return (this.lookupData[lookupDataSetName] || []).find(i => i.key === lookupKey);
      }
      return this.lookupData[lookupDataSetName];
    }
  }
  getLookupValue(lookupDataSetName: string, lookupId?: number) {
    if (this.lookupData) {
      if (lookupId) {
        return (this.lookupData[lookupDataSetName] || []).find(i => i.id.toString() === lookupId.toString());
      }
      return this.lookupData[lookupDataSetName];
    }
  }

  getLookupId(lookupDataSetName: string, lookupDisplay?: string) {
    if (this.lookupData) {
      if (lookupDisplay) {
        return (this.lookupData[lookupDataSetName] || []).find(i => i.display.toUpperCase() === lookupDisplay.toUpperCase());
      }
      return this.lookupData[lookupDataSetName];
    }
  }

  clearLookups() {
    this.lookupData = {};
  }
}